var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-card uk-margin-medium-bottom"},[_c('div',{staticClass:"md-card-content"},[_c('div',{staticClass:"videoWrapper"},[_c('video',{attrs:{"src":_vm.url,"controls":""}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }